import { Injectable } from '@angular/core';
import { catchError, map, Observable, tap, throwError } from 'rxjs';
import { FilterDTO,  SortDirection, VendorScoreCardAdminClient, VendorScoreCardAdminDataDTO } from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorBatchService } from 'src/app/base/shared/syncfusion/adaptor-batch-service.interface';
import { IPagedItems } from 'src/app/base/shared/syncfusion/paged-items.interface';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable({
  providedIn: 'root'
})
export class VendorScoreCardAdministrationService extends ShowInactiveService implements IAdaptorBatchService {

constructor(
  private vendorScoreCardAdminClient : VendorScoreCardAdminClient,
  public toastService: ToastService,
) {
  super();
}
  getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    return this.vendorScoreCardAdminClient.getAllVendorScoreCardAdminData()
      .pipe(
        map((items: []) => {
          return { items: items, totalNumberOfItems: items.length };
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }
  addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  
  deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  batchUpdate(data: any): Observable<any> {
    return this.vendorScoreCardAdminClient.updateAllVendorScoreCardAdminData(data)
      .pipe(
        tap(() => {
          this.toastService.showSuccess('i18n.domain.vendor-score-card.messages.update-success-message', 'i18n.domain.vendor-score-card.messages.update-success-message');
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError, error.response);
          }
          return throwError(() => error);
        }),
      );
  }

}
